module.exports = __webpack_public_path__ + "img/logo.b618574b.png";